<template>
  <div class="download text-white py-8">
    <div class="mx-auto" style="width:184px">
      <a href="https://xgames.zone">
        <img src="../assets/logo.png" style="height:34px" />
      </a>
    </div>
    <div v-if="notfound">
      <div class="my-2 text-xs text-white">
        <h1 class="text-2xl m-10">Not found</h1>
      </div>
    </div>

    <div class="imagebg" v-if="!notfound" :style="item.thumb ? `background-image: url(${item.thumb});` : ''">
      <div style="backdrop-filter: blur(8px); padding: 20px;" class="gradient">
        <div v-if="loader" class="animate-pulse flex space-x-4 my-7">
          <div class="h-4 bg-white rounded w-1/6 mx-auto"></div>
        </div>
        <div v-if="!loader">
          <h1 class="text-2xl my-4">{{ item.title }}</h1>
        </div>

        <div v-if="loader" class="rounded-md p-4 w-full my-5 mx-auto">
          <div class="animate-pulse flex space-x-4">
            <div class="rounded-full bg-white h-14 w-14"></div>
            <div class="flex-1 space-y-4 py-1">
              <div class="h-4 bg-white rounded w-full"></div>
              <div class="space-y-2">
                <div class="h-4 bg-white rounded w-1/4"></div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="!loader" class="rounded-md p-4 w-full my-5 mx-auto">
          <div class="flex space-x-4">
            <div class="p-3 border border-white border-opacity-10 bg-black rounded bg-opacity-30" style="max-height: 58px;">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#FFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-package"><line x1="16.5" y1="9.4" x2="7.5" y2="4.21"></line><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>
            </div>
            <div class="flex-1 space-y-1 py-1">
              <div class="text-left">
                {{ this.item.files[this.n] ? this.item.files[this.n].name : '' }}
              </div>
              <div class="space-y-2">
                <div class="h-4 text-left text-sm text-opacity-10">
                  {{ this.item.files[this.n] ? this.formatBytes(this.item.files[this.n].size, 2) : '' }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="btnloader" style="height:38px;"></div>
        <div v-if="!btnloader" class="p-2">
          <div class="mr-1 p-0.5 inline-block">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#FFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevrons-down"><polyline points="7 13 12 18 17 13"></polyline><polyline points="7 6 12 11 17 6"></polyline></svg>
          </div>
          <div class="inline-block align-top mx-2"><span style="box-shadow:0 2px 0 0 #B91C1C;">Solve the captcha to download</span></div>
          <div class="ml-1 p-0.5 inline-block">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#FFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevrons-down"><polyline points="7 13 12 18 17 13"></polyline><polyline points="7 6 12 11 17 6"></polyline></svg>
          </div>
        </div>

        <div v-if="btnloader" class="flex items-center justify-center mx-auto rounded h-24" style="background: rgba(0,0,0,0.6); 1px solid rgb(64 26 26 / 45%); width:322px">
          <Loader color="rgba(255,255,255,0.9)" />
          <div id="recaptcha-invisible" class="g-recaptcha" :data-sitekey="this.provider[this.currentProvider].sitekey" data-size="invisible"></div>
        </div>

        <div :class="`flex items-center justify-center mx-auto rounded h-24 ${ btnloader ? 'hidden' : '' }`" style="background: rgba(0,0,0,0.6); width:322px">
          <div id="recaptcha-visible" class="g-recaptcha" :data-sitekey="this.provider[this.currentProvider].sitekey"></div>
        </div>
      </div>
    </div>
    <div class="my-2 text-xs text-white">
      <div v-if="!loader" class="px-5 py-3 m-auto" style="max-width: 489px;">
        <span class="opacity-30">You will be redirected to {{ this.getStorageTitle() }}. xGames is not affiliated with {{ this.getStorageTitle() }}. You will be redirected to 3rd party website and xGames.zone is not responsible and has no ownership of any content provided by {{ this.getStorageTitle() }}.</span>
      </div>
      <div v-if="loader">&nbsp;</div>
    </div>
  </div>
</template>

<script>
import { captureMessage } from '@sentry/browser';
import { getItem, download } from '../services/api';
import Loader from '../components/Loader.vue';

export default {
  name: 'Download',
  components: {
    Loader,
  },
  data() {
    return {
      currentProvider: /^zh\b/.test(navigator.language) ? 'hcaptcha' : 'recaptcha',
      provider: {
        recaptcha: {
          sitekey: '6Lde8-4UAAAAAOBSgq96Tivh466k3piJbycs6A8I',
          script: 'https://www.google.com/recaptcha/api.js?onload=onLoadCallback&render=explicit'
        },
        hcaptcha: {
          sitekey: '72d18d89-26dd-451d-992e-7aa8ab97e616',
          script: 'https://js.hcaptcha.com/1/api.js?onload=onLoadCallback&render=explicit'
        },
      },
      loader: true,
      btnloader: true,
      notfound: false,
      n: 0,
      storage: 'k2s',
      item: {
        id: "",
        title: "",
        version: "",
        poster: "",
        files: [{
          name: "",
          size: 0,
        }],
      },
    };
  },
  mounted () {
    if (!/^[0-9a-fA-F]{24}$/.test(this.$route.params.id)) {
      this.notfound = true
      return;
    }
    if (this.$route.query.n && !isNaN(this.$route.query.n) && this.item.files[this.n]) {
      this.n = this.$route.query.n;
    }
    if (this.$route.query.source && this.$route.query.source) {
      this.storage = this.$route.query.source;
    }
    window.onLoadCallback = () => {
      this.getItem(this.$route.params.id, this.storage).then(() => this.execRecaptcha());
    }
    let recaptchaScript = document.createElement('script');
    recaptchaScript.setAttribute('src', this.provider[this.currentProvider].script);
    document.head.appendChild(recaptchaScript);
  },
  methods: {
    validate() {
      return true;
    },
    formatBytes(bytes, decimals) {
      if(bytes == 0) return '0 Bytes';
      const k = 1024,
          dm = decimals || 0,
          sizes = ['bytes', 'Kb', 'Mb', 'Gb', 'Tb'],
          i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },
    getStorageTitle() {
      const titles = {
        k2s: 'k2s.cc',
        fb: 'fboom.me',
        tz: 'tezfiles.com',
        mega: 'mega.nz',
        anonfile: 'anonfiles.com'
      };
      return titles[this.storage] || titles['k2s']
    },
    async checkfile (link) {
      if (!window.ym || !fetch) return;
      try {
        if (RegExp(/k2s.cc|fboom.me|tezfiles.com/).test(link)) {
          const id = new URL(link).pathname.split('/')[2];
          const js = await fetch('https://k2s-file-check.robbitorg.workers.dev/?id=' + id, {
            signal: AbortSignal.timeout(4000)
          }).then(result => result.json());
          window.ym(52088991,'reachGoal', js.is_available === false ? 'non-existing-file' : 'existing-file');
        }
      } catch {
        console.log('failed to check file');
      }
    },
    renderRecaptcha (container) {
      if (container === 'recaptcha-visible' && document.querySelector('#' + container)) {
        // window.grecaptcha.reset();
        document.querySelector('#' + container).innerHTML = '';
      }
      return window.grecaptcha.render(container, {
        sitekey: this.provider[this.currentProvider].sitekey,
        theme: 'dark',
        callback: this.tryDownload
      });
    },
    setTitle () {
      document.title = `${this.item.title} - download | xGames.zone`;
    },
    async tryDownload (token) {
      try {
        const result = await download(this.item.id, this.n, this.storage, token, this.currentProvider);
        if (result.reason === 'recaptcha') {
          this.renderRecaptcha('recaptcha-visible')
          this.btnloader = false
        } else {
          await this.checkfile(result.link);
          location.href = result.link
        }
      } catch (e) {
        captureMessage(`Try download failed: ${JSON.stringify(e)}`);
      }
    },
    async execRecaptcha () {
      this.btnloader = false // this.btnloader = true
      this.renderRecaptcha('recaptcha-visible')
      // const tokenInvisible = await window.grecaptcha.execute()
      // this.tryDownload(tokenInvisible)
    },
    async getItem(id, storage) {
      return getItem(id, storage)
        .then((data) => {
          if (Object.keys(data).length > 0) {
            this.item = data
            this.setTitle()
            this.loader = false
            this.notfound = false
          } else {
            this.notfound = true
            captureMessage('Unable to find item (no data)', { extra: { query: this.$route.query } });
          }
        }).catch((e) => {
          this.notfound = true
          captureMessage('Unable to find item', { extra: { query: this.$route.query, errstr: JSON.stringify(e) } });
        })
    },
  },
};
</script>

<style scoped>
  .imagebg {
    background-size:cover;
    background-position: 50% 50%;
    margin: 50px auto 0;
    max-width: 489px;
    width: 100%;
    border-radius: 9px;
    overflow: hidden;
    box-shadow: 0 1px 14px -9px #000;
    border: 1px solid rgb(20, 10, 10);
  }
  .imagebg > div {
    height: 100%;
    width: 100%;
  }
  .gradient {
    background: rgb(2,0,36);
    background: linear-gradient(0deg,rgb(5 0 0/98%),rgb(30 0 0/80%));
  }
  #recaptcha-invisible { 
    visibility: hidden;
  }
</style>
